export const saveToStorage =  (key, value) => {
     sessionStorage.setItem(`${key}`, value)
}

export const readFromStorage =  (key) => {
    let data =  sessionStorage.getItem(key)
    if(data) return data
    else return ''
}

export const removeFromStorage =  (key) => {
     sessionStorage.removeItem({
        key: key
    })
}

export const clearAll =  () => {
     sessionStorage.clear();
}

// // Save data to sessionStorage
// sessionStorage.setItem('key', 'value');
//
// // Get saved data from sessionStorage
// let data = sessionStorage.getItem('key');
//
// // Remove saved data from sessionStorage
// sessionStorage.removeItem('key');
//
// // Remove all saved data from sessionStorage
// sessionStorage.clear();
